import { Component, OnInit } from '@angular/core'
import { GraphqlService } from '@mprep/shared/data/services'
import { GraphqlResult } from '@mprep/shared/data/models'
import { Window, KBS_ENROLLMENT_PURCHASE_URL, PROGRAM_ID_EXTENSION_MAP } from '../shared'

@Component({
  selector: 'mp-profile',
  templateUrl: './profile.html',
  styleUrls: ['./profile.scss']
})
export class ProfileComponent implements OnInit {
  public enrollments = []
  public shipments = []
  
  private readonly _extensionMap = {
  '1000032078': '30012885'
  }

  constructor(
    private _graphqlService: GraphqlService,
    private _window: Window
  ) {}

  public ngOnInit() {
    this._graphqlService.query('enrollments')
    .subscribe((graphQlResult: GraphqlResult) => {
        if(graphQlResult.result.Enrollment){
          this.parse_enrollments(graphQlResult)
          const enrollmentIds: object[] = graphQlResult.result.Enrollment.map(enrollment => enrollment['enrollmentId']);
      
          if(enrollmentIds  && enrollmentIds.length > 0 && !enrollmentIds["errors"]){  
            this._graphqlService.query('shipments', {kbs_enrollment_ids: enrollmentIds})
            .subscribe((innerGraphQlResult: GraphqlResult) => {
                this.parse_shipments(innerGraphQlResult)               
            });            
          }          
        }
      
      })
  }
  
  public redirectToExtension(enrollment) {
    const productId = this._extensionMap[enrollment.KapClass.Product.id.toString()] || this._getTestlineExtension(enrollment)
    const url = KBS_ENROLLMENT_PURCHASE_URL.replace(':enrollmentId', enrollment.enrollmentId).replace(':productId', productId).replace(':quantity', '1')
    this._window.instance.open(url, '_blank')
  }
  
  public hasExtension(enrollment) {
    return !enrollment.Tutoring && enrollment.status === "Alumnus"
  }
  
  private _getTestlineExtension(enrollment) {
    return PROGRAM_ID_EXTENSION_MAP[parseInt(enrollment.KapClass.Product.programId)] 
  }
  
  
  private parse_enrollments(graphQlResult: GraphqlResult){
    this.enrollments = graphQlResult.result.Enrollment.filter((enrollment) => !enrollment.KapClass.Product.isFreeTrial)
  }
  
  private parse_shipments(graphQlResult: GraphqlResult){
    this.shipments = graphQlResult.result.Shipment
    .reduce((shipments, shipment) => {
        if (shipment.trackingNumber) {
            const associated_enrollemnt = this.enrollments.find(enrollment=>enrollment.enrollmentId == shipment.enrollmentId)
            shipment['name'] = associated_enrollemnt.KapClass.name
            shipments.push(shipment)
        }
        return shipments
    }, [])
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts